import { ThemeOptions } from '@material-ui/core/styles/createTheme';

export const northShoppingFortalezaTheme: ThemeOptions = {
  palette: {
    primary: {
      main: '#f65a02',
    },
    secondary: {
      main: '#b2ff59',
    },
    /**
     * @todo add tertiary do cliente
     */
    tertiary: {
      main: '#E2E543',
    },
    additionalColors: {
      promoHighligts: '#b9a69c',
    },
  },
};
